import { Modal, ModalProps, Row, Col } from 'antd';
import React, { useMemo } from 'react';
import KickImage from 'Reuseables/KickImage';
import 'antd/es/row/style/css';
import 'antd/es/col/style/css';
import 'antd/es/modal/style/css';
import ValidKTP from 'images/ktp-example.png';
import InvalidKTP from 'images/ktp-invalid-example.png';
import ValidNPWP from 'images/npwp-example.png';
import InvalidNPWP from 'images/npwp-invalid-example.png';
import Styles from './ModalPhotoGuidance.module.scss';

interface IModalPhotoGuidanceProps extends ModalProps {
  selectedType: 'NPWP' | 'e-KTP';
}

export const ModalPhotoGuidance: React.FC<IModalPhotoGuidanceProps> = ({
  selectedType,
  ...props
}) => {
  const image = useMemo(() => {
    if (selectedType === 'e-KTP') {
      return [ValidKTP, InvalidKTP];
    }

    return [ValidNPWP, InvalidNPWP];
  }, [selectedType]);

  return (
    <Modal width={560} style={{ borderRadius: 24 }} footer={null} {...props}>
      <Row>
        <span className={Styles['title']}>NPWP Photo Guidance</span>
      </Row>
      <Row
        gutter={20}
        align="middle"
        justify="space-between"
        style={{ marginTop: 28 }}
      >
        <Col span={12}>
          <KickImage src={image[0]} width={'100%'} />
          <div className={Styles['note']}>Recommended Photo</div>
        </Col>
        <Col span={12}>
          <KickImage src={image[1]} width={'100%'} />
          <div className={Styles['note']}>Rejected Photo</div>
        </Col>
      </Row>
      <Row style={{ marginTop: 32 }}>
        <ul>
          <span className={Styles['points-title']}>Please ensure the following</span>
          <li className={Styles['points-list']}>Original {selectedType || "NPWP"}, not a photocopy.</li>
          <li className={Styles['points-list']}>Do not use somebody else’s {selectedType || "NPWP"}.</li>
          <li className={Styles['points-list']}>All text is readable, no flash or glare.</li>
          <li className={Styles['points-list']}>Entire card is visible.</li>
        </ul>
      </Row>
    </Modal>
  );
};
